import { j as n } from "../../../../jsx-runtime.BREq8dyb.js";
import { Drawer as i } from "@mui/joy";
import { memo as c, useEffect as p } from "react";
import { b as D, c as x } from "../../../../react-hook-form.Du3weLRK.js";
const d = c(({
  children: r,
  open: t,
  onClose: s
}) => {
  const {
    reset: o
  } = D(), {
    isDirty: e,
    isSubmitting: a
  } = x();
  return p(() => t ? void 0 : o(), [t, o]), /* @__PURE__ */ n.jsx(i, { anchor: "right", disableEscapeKeyDown: e, onClose: (...m) => !a && s?.(...m), open: t, slotProps: {
    // TODO: Move to the theme
    content: {
      sx: {
        bgcolor: "transparent",
        boxShadow: "none",
        minWidth: "400px",
        p: {
          md: 3,
          sm: 0
        }
      }
    }
  }, children: r });
});
d.displayName = "DqDatasetSyncDrawer";
export {
  d as default
};
//# sourceMappingURL=DqDatasetSyncDrawer.js.map
